import { TrendDown } from 'Assets/icons/TrendDown'
import { TrendUp } from 'Assets/icons/TrendUp'
import React from 'react'
import { Trans } from 'react-i18next'
import { RowPart } from './DomainsTable.styled'
import { LoadingIcon } from '@clickcease/cc-client-components-lib'

type DomainRowProps = {
  address: string
  paidMarketingTrend: number
  botMitigationTrend: number
  hasBotZapping?: boolean
  hasPaidMarketing?: boolean
  isBmLoading?: boolean
}
export const NewActiveDomainRow = ({
  address,
  botMitigationTrend,
  paidMarketingTrend,
  hasBotZapping,
  hasPaidMarketing,
  isBmLoading,
}: DomainRowProps) => {
  const getTrendsIcon = (percentage?: number) => {
    if (!percentage || percentage === 0) {
      return <div style={{ width: '20px' }} />
    }
    return percentage > 0 ? (
      <TrendUp height={20} width={20} />
    ) : (
      <TrendDown height={20} width={20} />
    )
  }
  return (
    <>
      <RowPart css={{ flex: '1 1 50%' }}>{address}</RowPart>
      <RowPart css={{ flex: '1 1 25%', justifyContent: 'center' }}>
        {hasPaidMarketing && paidMarketingTrend !== 0 && (
          <>
            {getTrendsIcon(paidMarketingTrend)}
            <Trans ns="dashboard" i18nKey="overall_domain_performance.invalid_rate">
              {{ percentage: paidMarketingTrend }}% Invalid Rate
            </Trans>
          </>
        )}
      </RowPart>
      <RowPart css={{ flex: '1 1 25%', justifyContent: 'center' }}>
        {hasBotZapping && botMitigationTrend !== 0 && (
          <>
            {isBmLoading ? (
              <LoadingIcon width={'50px'} height={'50px'} />
            ) : (
              <>
                {getTrendsIcon(botMitigationTrend)}
                <Trans ns="dashboard" i18nKey="overall_domain_performance.invalid_rate">
                  {{ percentage: botMitigationTrend }}% Invalid Traffic
                </Trans>
              </>
            )}
          </>
        )}
      </RowPart>
    </>
  )
}
